import { ref } from "vue"

export function useHostStore() {
  const hostStores = ref<any>(null)
  const isReady = ref(false)

  const initializeStores = () => {
    if (window.__HOST_STORES__) {
      hostStores.value = window.__HOST_STORES__
      isReady.value = true
    } else {
      console.warn("Host stores not available")
    }
  }

  // Getters
  const getGlobalStore = () => {
    if (isReady.value === false) {
      initializeStores()
    }
    return hostStores.value?.globalStore
  }

  const getUserStore = () => {
    if (isReady.value === false) {
      initializeStores()
    }

    return hostStores.value?.userStore
  }

  // Common actions
  const getUserPreferences = () => {
    return getGlobalStore()?.userPreferences || {}
  }

  const setFavorites = (favorites: string) => {
    getGlobalStore()?.setFavorites(favorites)
  }

  const getCurrentUser = () => {
    return getUserStore()?.currentUser || null
  }

  return {
    hostStores,
    isReady,
    initializeStores,
    getGlobalStore,
    getUserStore,
    getUserPreferences,
    setFavorites,
    getCurrentUser,
  }
}
